import React, { useState, useEffect } from "react";
import {
  Container,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Button,
  Typography,
  Tooltip,
  Box,
  TableSortLabel,
  IconButton,
} from "@mui/material";
import { SPARES_BY_SPARE_ID_LISTING_COLUMNS } from "../../utils/constant";
import RecordNotFound from "../../common/RecordNotFound";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { visuallyHidden } from "@mui/utils";
import { FindSpareByArticleCodeService } from "../../services/ModelViewService";
import {
  SpareListingBySpareIdService,
  LinkAlternateSpareWithSpareService,
  StatusListingService,
  PartTypeListingService,
  SpareListingBySpareIdOnSearchService,
} from "../../services/SpareSearchService";
import { useForm } from "react-hook-form";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import AddAlternateSpare from "./AddAlternateSpare";
import {
  brandListingOnSelectedBrickService,
  brickListingOnSelectedBrandService,
} from "../../services/ModelViewService";
import { Link } from "react-router-dom";
import Add from "@mui/icons-material/Add";
import DownloadIcon from "@mui/icons-material/Download";
import download from "downloadjs";
import { DownloadAltAndLinkedSpareService } from "../../services/DownloadAltAndLinkedSpareService";
import useGlobalState from "../../Context";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const SpareView = () => {
  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [nameSearch, setNameSearch] = useState("");
  const [sparesBySpareId, setSparesBySpareId] = useState([]);
  const [searchedRows, setSearchedRows] = useState(sparesBySpareId);
  const [totalElements, setTotalElements] = useState(0);
  const [openAddModelDialog, setOpenAddModelDialog] = useState(false);
  const [formData, setFormData] = useState({});
  const [articleCode, setArticleCode] = useState(null);
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [brandSearch, setBrandSearch] = useState(null);
  const [brickSearch, setBrickSearch] = useState(null);
  const [partTypeSearch, setPartTypeSearch] = useState(null);
  const [statusSearch, setStatuSearch] = useState(null);
  const [searchModelNameValue, setSearchModelNameValue] = useState("");
  const [searchwith, setSearchwith] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [partTypeList, setPartTypeList] = useState([]);
  const [brandListOnBrickId, setBrandListOnBrickId] = useState([]);
  const [brickListOnBrandId, setBrickListOnBrandId] = useState([]);
  const [disableDownloadButton, setDisableDownloadButton] = useState(true);
  const [sortValue, setSortValue] = useState(null);
  const [noRecord, setNoRecord] = useState(false);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("code");
  // const auth = JSON.parse(localStorage.getItem("SPMS_INTERNAL_STATE"));
  const [{ auth, spareAccessRights }, dispatch] = useGlobalState();
  const loginParam = auth.ldapParam;
  const navigate = useNavigate();
  const { state } = useLocation();
  const { id } = useParams();
  const sID = id.replace(":id", id);
  const formOption = {
    defaultValues: { ...formData },
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm(formOption);

  useEffect(() => {
    getSpareBySpareId("code", true, parseInt(sID));
    fetchStatusList();
    fetchPartTypeList();
    fetchBrandListOnSelectedBrick();
    fetchBrickListOnSelectedBrand();
  }, []);

  useEffect(() => {
    reset(formData);
  }, [openAddModelDialog]);

  const goBack = () => {
    if(state.fromModel){
      navigate("/model-search/model-view",{state:{modelId: state.model_id,brandName: state?.brand_name,
        modelCode: state?.model_code,}});
    }
    else{
      navigate("/spare-search");
    }
    //navigate("/spare-search");
  };

  const getSpareBySpareId = async (sortBy, isAsc, id) => {
    try {
      const obj = {
        spareId: id,
        pageSize: 10,
        pageNumber: 0,
        sortDirection: isAsc ? "DESC" : "ASC",
        sortBy: sortBy,
        brandId: 0,
        brickId: 0,
        status: 0,
        partTypeId: 0,
        modelName: "",
      };
      const res = await SpareListingBySpareIdService(obj);
      if (res.statusCode === 6) {
        setSparesBySpareId(res.data.content);
        if (res.data.content?.length === 0) {
          setNoRecord(true);
        } else {
          setNoRecord(false);
        }
        if (res.data.content.length > 0) {
          setDisableDownloadButton(false);
        }
        setTotalElements(res.data.totalElements);
      } else {
        showNotification("Error", res.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };
  useEffect(() => {
    const selectedRows =
      sparesBySpareId &&
      sparesBySpareId.filter(
        (row) =>
          row && row.defSpareActionName && row.defSpareActionName.toUpperCase()
      );
    setSearchedRows(selectedRows);
  }, [nameSearch, sparesBySpareId]);

  const onBrandClick = (id) => {
    setBrandSearch(id);
    fetchBrickListOnSelectedBrand(id);
  };

  const onBrickClick = (id) => {
    setBrickSearch(id);
    fetchBrandListOnSelectedBrick(id);
  };

  const onPartTypeClick = (id) => {
    setPartTypeSearch(id);
  };

  const onStatusClick = (id) => {
    setStatuSearch(id);
  };

  const searchText = async (e) => {
    setSearchModelNameValue(e.target.value);
  };

  const searchOnClick = async (modelName) => {
    try {
      setLoading(true);
      const spareRequestObj = {
        brandId: brandSearch,
        brickId: brickSearch,
        modelName,
        status: statusSearch,
        partTypeId: partTypeSearch,
        spareId: parseInt(sID),
        pageNumber: 0,
        pageSize: 10,
        sortDirection: "DESC",
        sortBy: "spareId",
      };
      await onSearchSpareList(spareRequestObj);
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
    setSearchwith(modelName);
    // setNameSearch(searchModelNameValue);
  };

  const onSearchSpareList = async (values) => {
    try {
      setLoading(true);
      const spareRequestObj = {
        brandId: values?.brandId ?? null,
        brickId: values?.brickId ?? null,
        modelName: values?.modelName ?? null,
        status: values?.status ?? null,
        partTypeId: values?.partTypeId ?? null,
        pageNumber: values?.pageNumber ?? 0,
        pageSize: values?.pageSize ?? 10,
        sortDirection: values?.sortDirection,
        sortBy: values?.sortBy,
        spareId: values?.spareId,
      };
      const spareListingResponse = await SpareListingBySpareIdOnSearchService(
        spareRequestObj
      );

      if (spareListingResponse.statusCode == "6") {
        setSparesBySpareId(spareListingResponse.data.content);
        setTotalElements(spareListingResponse.data.totalElements);
      } else {
        showNotification("Error", spareListingResponse.message, "error");
      }
    } catch (err) {
      showNotification("Error", err.message ?? "Failed to fetch user details");
    } finally {
      setLoading(false);
    }
  };

  const handleClickOpenOnAdd = async () => {
    setOpenAddModelDialog(true);
  };

  const handleClose = () => {
    setOpenAddModelDialog(false);
    setFormData({});
  };

  const handleChangeRowsPerPage = async (event) => {
    const paginationValues = {
      pageNumber: 0,
      pageSize: +event.target.value,
    };

    await handleModeViewTableChanges(paginationValues, false);
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);
      const paginationValues = {
        pageNumber: newPage,
        pageSize: rowsPerPage,
      };
      await handleModeViewTableChanges(paginationValues, true);
    }
    setPage(newPage);
  };

  const handleModeViewTableChanges = async (paginationValues, isUpdate) => {
    try {
      setLoading(true);
      const obj = {
        spareId: parseInt(sID),
        pageNumber: paginationValues?.pageNumber ?? 0,
        pageSize: paginationValues?.pageSize ?? 10,
        sortDirection: "ASC",
        sortBy: "spareId",
      };
      const response = await SpareListingBySpareIdService(obj);
      if (response.statusCode == "6") {
        if (isUpdate) {
          setSparesBySpareId([...sparesBySpareId, ...response.data.content]);
        } else {
          setSparesBySpareId(response.data.content);
        }
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
    }
  };

  const getSpareByArticleCode = async () => {
    try {
      setLoading(true);
      const response = await FindSpareByArticleCodeService(articleCode);
      if (response.statusCode === 6) {
        reset(formData);
        setFormData({
          description: response?.data.description,
          partTypeName: response?.data.partTypeName,
          spareId: response?.data.spareId,
        });
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
    }
  };

  const fetchStatusList = async () => {
    try {
      const statusListingResponse = await StatusListingService();
      if (statusListingResponse.statusCode == "6") {
        setStatusList(statusListingResponse.data);
      } else {
        showNotification("Error", statusListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchPartTypeList = async () => {
    try {
      const partTypeListingResponse = await PartTypeListingService();
      if (partTypeListingResponse.statusCode == "6") {
        setPartTypeList(partTypeListingResponse.data);
      } else {
        showNotification("Error", partTypeListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchBrandListOnSelectedBrick = async (id) => {
    try {
      const brandListingResponse = await brandListingOnSelectedBrickService(id);
      if (brandListingResponse.statusCode == "6") {
        setBrandListOnBrickId(brandListingResponse.data);
      } else {
        showNotification("Error", brandListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const fetchBrickListOnSelectedBrand = async (id) => {
    try {
      const brickListingResponse = await brickListingOnSelectedBrandService(id);
      if (brickListingResponse.statusCode == "6") {
        setBrickListOnBrandId(brickListingResponse.data);
      } else {
        showNotification("Error", brickListingResponse.message, "error");
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      // setLoading(false);
    }
  };

  const onLinkSpareWithSpareSubmit = async () => {
    try {
      setLoading(true);
      const requestBody = {
        spareId: parseInt(id),
        altSpareId: formData.spareId,
        createdOn: new Date(),
        createdBy: loginParam.userId,
        createdByName: loginParam.name,
        modifiedOn: new Date(),
        modifiedBy: loginParam.userId,
      };
      const response = await LinkAlternateSpareWithSpareService(requestBody);
      if (response.statusCode == "6") {
        showNotification("Success", response.message, "success");
        handleClose();
        getSpareBySpareId("code", true, sID);
        setPage(0);
        setMaxPage(0);
      } else {
        showNotification("Error", response.message, "error");
      }
    } catch (e) {
      showNotification("Error", "Failed to fetch site filter search data");
    } finally {
      setLoading(false);
    }
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    getSpareBySpareId(property, isAsc, sID);
    setSortValue(isAsc ? "DESC" : "ASC");
    setPage(0);
    setMaxPage(0);
  };

  const createSortHandler = (property) => (event) => {
    handleRequestSort(event, property);
  };
  return (
    <>
      <Container maxWidth="lg" sx={{ mt: 7 }}>
        <Grid
          container
          spacing={1}
          sx={{ pl: 3, pr: 3, mt: 1, mb: 0.5 }}
          display="flex"
        >
          <Grid item xs={7}>
            <Typography
              align="left"
              sx={{
                mr: "auto",
                mt: 1 / 2,
                color: "#003f93",
                // fontWeight: "bold",
              }}
              variant="h6"
            >
              <IconButton sx={{ color: "#003f93" }}>
                <ArrowBackIcon onClick={goBack} />
              </IconButton>
              Spare Details : {state.code} / {state.spareDescription}
            </Typography>
          </Grid>
          <Grid item xs={5} sx={{ mb: 1 }}>
            <Typography align="right">
              {spareAccessRights.addDelete ? (
                <Button
                  variant="contained"
                  onClick={() => {
                    handleClickOpenOnAdd();
                  }}
                  sx={{ ml: 1 }}
                  className="button-primary-alt-contained"
                  startIcon={<Add />}
                >
                  Add Alternate Spare
                </Button>
              ) : null}
              {loginParam.rilUser ? (
                <Tooltip title="Download Alternate Spare">
                  <Button
                    variant="contained"
                    className="button-primary-alt-contained"
                    startIcon={<DownloadIcon />}
                    sx={{ ml: 1 }}
                    disabled={disableDownloadButton}
                    onClick={async () => {
                      try {
                        setLoading(true);
                        const response = await DownloadAltAndLinkedSpareService(
                          0,
                          parseInt(sID)
                        );
                        const content = response.headers["content-type"];
                        download(
                          response.data,
                          "AlternateSpareList.csv",
                          content
                        );
                      } catch (err) {
                        showNotification("Error", "Failed To Fetch");
                      } finally {
                        setLoading(false);
                      }
                    }}
                  >
                    Download
                  </Button>
                </Tooltip>
              ) : null}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          containervdirection="row"
          justifyContent="center"
          alignItems="center"
        >
          <Grid item xs={12} mb={5} sx={{ pl: 3, pr: 3, mt: 2 }}>
            <Paper elevation={3} variant="elevation">
              <TableContainer sx={{ maxHeight: 720 }}>
                <Table
                  sx={{ maxHeight: 720 }}
                  aria-labelledby="tableTitle"
                  size="small"
                  className="vendorSuplierTable"
                >
                  <TableHead>
                    <TableRow key={"1"}>
                      {SPARES_BY_SPARE_ID_LISTING_COLUMNS.map((headCell) => (
                        <TableCell
                          className="tableHeader1"
                          size="small"
                          variant="head"
                          key={headCell.id}
                          sx={{ pt: 1.5, pb: 1.5 }}
                          style={{
                            minWidth: headCell.minWidth,
                            fontWeight: "bold",
                            color: "#003A6B",
                          }}
                          sortDirection={
                            orderBy === headCell.id ? order : false
                          }
                        >
                          <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : "asc"}
                            onClick={createSortHandler(headCell.id)}
                            disabled={
                              (headCell.id === "#" ||
                                headCell.id === "defSpareActionName") &&
                              true
                            }
                          >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                              <Box component="span" sx={visuallyHidden}>
                                {order === "desc"
                                  ? "sorted descending"
                                  : "sorted ascending"}
                              </Box>
                            ) : null}
                          </TableSortLabel>
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  {searchedRows && searchedRows.length > 0 ? (
                    <TableBody sx={{ mt: 2 }}>
                      {searchedRows
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => {
                          return (
                            <TableRow
                              tabIndex={-1}
                              hover
                              role="checkbox"
                              key={row.spareId}
                            >
                              {/* <TableCell size="medium" key={"#"}>
                                {index + 1 ?? "-"}
                              </TableCell> */}    
                              <TableCell size="medium" key={"code"}>
                                {`${row["code"]}` ?? "-"}
                              </TableCell>
                              <TableCell size="medium" key={"description"}>
                                {row["description"] ?? "-"}
                              </TableCell>
                              <TableCell size="medium" key={"brandName"}>
                                {row["brandName"] ?? "-"}
                              </TableCell>
                              <TableCell size="medium" key={"brickName"}>
                                {row["brickName"] ?? "-"}
                              </TableCell>
                              <TableCell size="medium" key={"partName"}>
                                {row["partName"] ?? "-"}
                              </TableCell>
                              <TableCell
                                size="medium"
                                key={"defSpareActionName"}
                              >
                                {row["defSpareActionName"] ?? "-"}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                    </TableBody>
                  ) : (
                    <TableBody>
                      <TableRow>
                        {noRecord ? (
                          <TableCell colSpan={7}>
                            <RecordNotFound />
                          </TableCell>
                        ) : (
                          <TableCell colSpan={7} />
                        )}
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
              {searchedRows && searchedRows.length > 0 ? (
                <TablePagination
                  className="newPagination"
                  rowsPerPageOptions={[10, 25, 50, 100]}
                  component="div"
                  count={totalElements}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              ) : null}
            </Paper>
            <AddAlternateSpare
              openDialog={openAddModelDialog}
              handleClose={handleClose}
              register={register}
              handleSubmit={handleSubmit}
              errors={errors}
              formData={formData}
              getSpareByArticleCode={getSpareByArticleCode}
              setArticleCode={setArticleCode}
              onLinkSpareWithSpareSubmit={onLinkSpareWithSpareSubmit}
              setValue={setValue}
            />
          </Grid>
        </Grid>
        {/* </Paper> */}
      </Container>
    </>
  );
};

export default SpareView;
